module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAcCAYAAAB/E6/TAAAAV0lEQVRIS2NkoDL4O4PhPzYjGalsD8OoRWSH6GjQDVzQ4Qp75gwGlCxCcRyNWoQeyUQXQaNBN3BBR2nYE52PRi1Cj+TRoMOoFogNEmLVMY6mutFUBwsBAM/hqE1Il8ZtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/live-label.png
// module id = JSBG
// module chunks = 1